<template>
  <div class="navbar-container" :class="brand.name">
    <div class="logo-left-all-screen" :class="brand.name" >
      <Logo :brand="brand" :dealer="dealer" class="brand.name left" v-if="brand.name == 'mazda' "></Logo>
    </div>
    <DealerInfo v-if="singleLineDealerInfo" :brand="brand" :dealer="dealer" :showPhoneDetails="showPhoneDetails"></DealerInfo>
    <div class="navbar-position" :class="brand.name">
      <div class="navitem-container" :class="brand.name">
        <Logo :brand="brand" :dealer="dealer" class="logo" :class="brand.name" ></Logo>
        <div class="dealership-name-small-screen" v-if="!singleLineDealerInfo">
          <a class="dealership-url" :class="brand.name" :href="dealer.url.home" rel="noopener" target="_blank" aria-label="link to dealership">{{ dealer.name }}</a>
        </div>
        <div class="button-container">
          <div id="nav-location" class="nav-location" v-on:click="trackClickOnLocation">
            <a v-bind:href="$store.getters.googleMapLink" rel="noopener" target="_blank" aria-label="map"><i class="fa fa-map-marker"></i></a>
          </div>
          <div id="nav-phone-toggle" class="nav-phone-toggle" v-on:click="toggleDetails($event)">
            <i class="fa fa-phone" target="nav-phone-collapse" ></i>
          </div>
          <div v-if="ecommEnabled" id="nav-cart" class="nav-cart" v-on:click="showCart($event)">
            <i class="fa fa-shopping-cart"></i>
            <i class="fa fa-calendar-check-o cart-schedule" v-if="needsAppointment"></i>
            <span :class="brand.name" class="cart-count" v-show="showCartCount">{{ getTotalCount() }}</span>
          </div>
          <div id="nav-menu-toggle" class="nav-menu-toggle" v-on:click="toggleMenu($event)">
            <i class="fa fa-bars" target="nav-menu-collapse" ></i>
          </div>
        </div>
        <div class="break1" :class="brand.name"></div>
        <div class="menu-container" :class="brand.name" v-show="showMobileMenu || isWeb">
          <ul id="nav-text-collapse" class="navbar-nav" :class="brand.name" >
            <li class="nav-item" v-on:click="toggleMenu($event)"><router-link to="/">In-Store Offers</router-link></li>
            <li class="nav-item" v-on:click="toggleMenu($event)" v-show="scheduleEnabled"><a v-on:click="scheduleService('navigation')" link-classes="text-nowrap cursor:pointer">Quick Schedule</a></li>
            <li class="nav-item" v-on:click="toggleMenu($event)"><router-link to="/tips" v-show="brand.showTipsOnMenu == true">Tips &amp; Guides</router-link></li>
            <li class="nav-item" v-on:click="toggleMenu($event)" v-show="serviceEnabled && (productOptionsByCategory('service') || productOptionsByCategory('accessories'))"><router-link :to="{ name: 'servicelist', params: { step: 1 } }">Online Exclusive Offers</router-link></li>
            <li class="nav-item" v-on:click="toggleMenu($event)" v-show="ppmEnabled && productOptionsByCategory('maintenance')"><router-link :to="{ name: 'maintenance', params: { step: 1 } }">{{ planTitle('maintenance') }}</router-link></li>
            <li class="nav-item" v-on:click="toggleMenu($event)" v-show="warrantyEnabled && productOptionsByCategory('warranty')"><router-link :to="{ name: 'warranty', params: { step: 1 } }">{{ planTitle('warranty') }}</router-link></li>
            <li class="nav-item" v-on:click="toggleMenu($event)" v-show="protectionEnabled && productOptionsByCategory('protection')"><router-link :to="{ name: 'protection', params: { step: 1 } }">{{ planTitle('protection') }}</router-link></li>
          </ul>
        </div>
        <div class="break2" :class="brand.name"></div>
        <div class="nav-phone-container" v-show="showPhoneDetails" v-if="!singleLineDealerInfo">
          <DealerPhone :brand="brand" :dealer="dealer" v-show="showPhoneDetails"></DealerPhone>
        </div>
      </div>
      <div class="address-container" :class="brand.name">
        <div v-if="ecommEnabled" id="nav-cart" class="nav-cart" v-on:click="showCart($event)" v-show="isWeb">
          <i class="fa fa-shopping-cart"></i>
          <i class="fa fa-calendar-check-o cart-schedule" v-if="needsAppointment && scheduleEnabled"></i>
          <span :class="brand.name" class="cart-count" v-show="showCartCount">{{ getTotalCount() }}</span>
        </div>
        <div v-if="!ecommEnabled">
        </div>
        <DealerInfo :brand="brand" :dealer="dealer" v-if="!singleLineDealerInfo" :showPhoneDetails="showPhoneDetails"></DealerInfo>
      </div>
    </div>
  </div>
</template>
<script>
import Logo from '@/components/Logo'
import DealerInfo from '@/components/DealerInfo'
import DealerPhone from '@/components/DealerPhone'
import { mapGetters } from 'vuex'

export default {
  name: 'AppNavigation',
  props: {
    brand: Object,
    dealer: Object
  },
  data: function () {
    return {
      showMobileMenu: false,
      showPhoneDetails: false,
      showCartCount: false,
      windowWidth: window.innerWidth
    }
  },
  components: {
    Logo,
    DealerInfo,
    DealerPhone
  },
  computed: {
    ...mapGetters({
      productOptionsByCategory: ['productVariants/productOptionsByCategory'],
      needsAppointment: ['session/needsAppointment'],
      ppmEnabled: 'ecommPpmEnabled',
      serviceEnabled: 'ecommServiceEnabled',
      ecommEnabled: 'ecommEnabled',
      scheduleEnabled: 'scheduleEnabled',
      warrantyEnabled: 'ecommWarrantyEnabled',
      protectionEnabled: 'ecommProtectionEnabled'
    }),
    /* used to show menu on larger screen */
    isWeb () {
      return this.windowWidth >= 992
    },
    singleLineDealerInfo () {
      if (this.brand.name === 'bmw' || this.brand.name === 'mazda' || this.brand.name === 'lexus' || this.brand.name === 'subaru' || this.brand.name === 'ford') {
        return true
      } else {
        return false
      }
    }
  },
  mounted () {
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    }, { passive: true })
  },
  methods: {
    planTitle (category) {
      return this.brand[category] && this.brand[category].planTitle
    },
    scheduleService: function (source) {
      if (this.$route.name === 'appointment') {
        this.$nextTick(() => { this.$router.go() })
      } else {
        this.$nextTick(() => { this.$router.replace({ name: 'appointment' }).catch(() => {}) })
      }
    },
    showCart (event) {
      if (this.needsAppointment) {
        this.$nextTick(() => { this.$router.replace({ name: 'appointment' }).catch(() => {}) })
      } else {
        this.$nextTick(() => { this.$router.replace({ name: 'cart' }).catch(() => {}) })
      }
    },
    /* used to show/hide menu on mobile screen */
    toggleMenu: function (event) {
      this.showMobileMenu = !this.showMobileMenu
    },
    toggleDetails: function (event) {
      this.showPhoneDetails = !this.showPhoneDetails
    },
    trackClickOnLocation () {
      this.$store.dispatch('track/gaEvent', { vm: this, category: 'location', action: 'click', label: 'icon' })
      this.$store.dispatch('track/facebookEvent', { event: 'Loc-Click-Icon' })
    },
    getTotalCount () {
      if (this.$store.getters['cart/totalItems'] > 0) {
        this.showCartCount = true
      } else {
        this.showCartCount = false
      }
      return this.$store.getters['cart/totalItems']
    }
  }
}
</script>

<style scoped>
/* background for entire nav area */
.navbar-container {
  box-sizing: border-box;
  background-color: var(--banner-background-color);
  color: var(--banner-text-color);
  align-self: start;
  position: sticky; /* overflow has to be visible for all ancestor elements */
  position: -webkit-sticky; /* needed for Safari */
  top: 0;
  z-index: 99;
}
/* positioning for entire navigation bar */
.navbar-position {
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 1;
  text-align: left;
  padding: 0.5rem 1rem;
  align-items: center; /* aligns nav content in center of nav area */
}
/* container for navigation sub sections */
.navitem-container{
  display: flex;
  column-gap: 5px;
  width: 100%; /* aligns buttons right and rest of menu left */
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  position: relative;
  padding-bottom: 0.5rem;
  min-height: 50px;
}
.dealership-name-small-screen {
  align-self: center;
}
/* container for button sub section */
.button-container {
  column-gap: 3px;
  justify-content: flex-end;
  flex-direction: row;
  display: flex;
  width: 20%;
  position: absolute;
  right: 0;
}
/* line break for mobile navigation */
.break1,
.break2 {
  flex-basis: 100%;
  height: 0px;
}
/* Container for location */
.location-container {
  height: 500px;
  width: 100%;
}
/* cart-count */
.cart-count {
  color: var(--variant-alt-color);
  background-color: var(--variant-color);
  padding: 3px 10px;
  font-size: 50%;
  border-radius: 25px;
  position: absolute;
  right: -10px;
  font-weight: bold;
}
.cart-schedule {
  color: var(--variant-alt-color);
  background-color: var(--variant-color);
  position: absolute;
  padding: 3px 5px;
  border-radius: 25px;
  font-size: 50%;
  left: 20px;
}
/* navigation only */
.nav-item {
  display: inline-grid;
  flex-wrap: nowrap;
}
.navbar-nav {
  font-family: var(--nav-font-stack);
  display: flex;
  flex-direction: column;
}
.navbar-nav > li > a {
  text-decoration: none;
  border-bottom: 1px solid transparent;
}
.navbar-nav > li > a, a:focus {
  color: var(--url-text-color);
}
.navbar-nav > li > a:hover {
  color: var(--url-hover-text-color);
}
/* end navigation only */
/* navitem styles */
.address-container{
  justify-content: flex-end;
  display: none;
  width: 100%;
}

.dealership-url {
  color: var(--banner-text-color);
  text-decoration: none;
}
.nav-cart {
  font-size:25px;
  color: var(--url-text-color);
  background-color: var(--banner-background-color);
  border: none;
  padding: 0px 0px 1px 8px;
  cursor: pointer;
  position: relative;
  margin-right: 5px;
}
.nav-menu-toggle,
.nav-phone-toggle,
.nav-location {
  font-size:25px;
  color: var(--url-text-color);
  background-color: var(--banner-background-color);
  border: none;
  padding: 0px 0px 1px 8px;
  cursor: pointer;
}
.fa-map-marker {
  color: var(--url-text-color);
}
.nav-phone-container {
  padding-top: 10px;
}
/* end navitem styles */
/* brand level customization of navigation */
.navbar-position.mini {
  padding-top: 10px;
  padding-bottom: 10px;
}
.navbar-nav.mini {
  font-size: 14px;
  text-transform: uppercase;
}
.navbar-nav.mercedes-benz {
  font-weight: bold;
  text-transform: uppercase;
}
.navbar-nav.jaguar {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
}
.navbar-nav.land-rover {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
}
.navbar-nav.cadillac{
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 1.25px;
  font-weight: bold;
}
.navbar-nav.buick,
.navbar-nav.gmc {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1.25px;
  font-weight: bold;
}
.navbar-nav.honda {
  text-transform: uppercase;
  font-size: 14px;
}
.navbar-nav.acura {
  text-transform: uppercase;
  font-size: 15px;
}
.navbar-nav.infiniti {
  text-transform: uppercase;
  font-size: 14px;
}
.navbar-position.mazda {
  justify-content:flex-end;
}
.dealership-name-small-screen,
.logo.mazda,
.address-container.mazda {
  display: none;
}
.navbar-nav.mazda {
  text-transform: uppercase;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 1.25px;
  vertical-align: top;
}
.logo-left-all-screen.mazda {
  position: absolute;
  top: 20px;
  left: 25px;
  order: -1;
  z-index: 99;
}
.navbar-position.lexus {
  justify-content: center;
}
.menu-container.lexus {
  justify-content: center;
  text-align: center;
  align-self: center;
  width: 100%;
}
.navbar-nav.lexus {
  text-transform: uppercase;
  font-size: 11px;
  letter-spacing: 1.5px;
}
.navbar-nav.mitsubishi {
  text-transform: uppercase;
  font-size: 16px;
}
.navbar-nav.subaru {
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 1.5px;
}
.navbar-nav.ford {
  font-size: 14px;
  letter-spacing: 1.5px;
}
.navbar-nav.lincoln {
  text-transform: uppercase;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 1.5px;
}
/* end navigation only */
/* end brand level customization of navigation */
/* This is one off change to give more spacing for dealership name
   on iPhone 5 size screens.  Very minor. */
@media only screen and (max-width: 320px) {
  .navbar-position.mini {
    padding-left: 5px;
    padding-right: 5px;
  }
}
@media only screen and (min-width: 576px) {
}
@media only screen and (min-width: 768px) {
/* end navigation item styles */
}
@media only screen and (min-width: 992px) {
  .menu-container {
    display:flex;
    width: 80%;
  }
  .menu-container.porsche,
  .menu-container.gmc,
  .menu-container.dodge,
  .menu-container.chrysler {
    width: 70%;
  }
  .nav-cart {
    padding: 10px;
  }
  .cart-count {
    top: 2px;
    right: 15px;
  }
  .nav-location,
  .break1,
  .button-container,
  .nav-phone-container,
  .dealership-name-small-screen,
  .break2.lincoln,
  .break2.infiniti,
  .break2.lexus,
  .break2.mercedes-benz  {
    display: none;
  }
  .navbar-nav {
    flex-direction: row;
    flex-wrap: nowrap;
  }
  .navitem-container {
    align-items: center; /* aligns logo and menu */
    width: 80%
  }
  /* navigation item styles */
  .navbar-nav > li > a {
    text-decoration: none;
    border-bottom: 1px solid transparent;
    padding: 0px 10px; /* adding it here prevents extra padding if menu item hidden */
  }
  .address-container {
    display: grid;
    flex-direction: column;
    grid-template-columns: 70px auto;
    justify-content: space-evenly;
    width: 40%;
    max-width: 400px;
  }
  .address-container.lexus,
  .address-container.bmw {
    justify-content: flex-end;
    width: 10%;
  }
  .address-container.ford {
    justify-content: flex-end;
    width: 5%;
  }
  .navbar-nav.cadillac > li > a {
    padding-top: 10px;
    padding-bottom: 15px;
  }
  .navbar-nav.gmc > li > a {
    padding-top: 3px;
  }
  .navbar-nav > li > a:hover {
    border-bottom: 1px solid var(--url-hover-underline-color);
  }
  .navbar-nav.mini > li > a:hover,
  .navbar-nav.cadillac > li > a:hover,
  .navbar-nav.honda > li > a:hover,
  .navbar-nav.hyundai > li > a:hover,
  .navbar-nav.subaru > li > a:hover {
    padding-bottom: 15px;
    border-bottom: 4px solid;
    border-bottom-color: var(--url-hover-underline-color);
  }
  .navbar-nav.kia > li > a:hover {
    padding-bottom: 5px;
    border-bottom: 2px solid;
    border-bottom-color: var(--url-hover-underline-color);
  }
  .navitem-container.infiniti,
  .navitem-container.mercedes-benz,
  .navitem-container.lincoln
  .navitem-container.lexus,
  .navitem-container.kia,
  .navitem-container.volvo {
    width: 100%;
  }
  .navitem-container.bmw,
  .navitem-container.ford {
    width: 90%;
  }
  .navitem-container.mazda {
    justify-content:flex-end;
  }
  .navbar-nav.audi {
    font-size: 15px;
  }
  .menu-container.volvo,
  .menu-container.infiniti,
  .menu-container.lexus {
    width: 75%;
    justify-content: flex-end;
    text-align: end;
  }
  .menu-container.mazda {
    width: 100%;
    justify-content: flex-end;
    text-align: end;
  }
  .navbar-nav.lincoln > li > a:hover {
    border-top: 2px solid;
    padding-top: 10px;
    border-bottom: 0px;
    border-top-color: var(--url-hover-underline-color);
  }
  .navbar-nav.porsche > li > a:hover {
    padding-bottom: 15px;
    border-bottom: 2px solid;
  }
  .navbar-nav.kia > li,
  .navbar-nav.volvo > li {
    padding: 0px 10px;
  }
  .navbar-nav.lincoln {
    font-size: 13px;
  }
  .navbar-position.mazda {
    padding-right: 0.5rem;
  }
}
@media only screen and (min-width: 1200px) {
  .navbar-nav.acura {
    font-size: 18px;
  }
  .address-container {
    max-width: 500px;
  }
}
</style>
